// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"9bd18d9c","351":"8fd7b656","418":"71e0dc41","513":"1cbdae5d","604":"1af52163","732":"0e18395f","769":"dcd3267f","900":"7c75c94d"}[chunkId] + ".chunk.js";
};